import { render, staticRenderFns } from "./AdditionalColors.vue?vue&type=template&id=9b75d35e&"
import script from "./AdditionalColors.vue?vue&type=script&lang=js&"
export * from "./AdditionalColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/philippneumann/Documents/frontendstudios/Gonser/GonserDT-Theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b75d35e')) {
      api.createRecord('9b75d35e', component.options)
    } else {
      api.reload('9b75d35e', component.options)
    }
    module.hot.accept("./AdditionalColors.vue?vue&type=template&id=9b75d35e&", function () {
      api.rerender('9b75d35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/AdditionalColors.vue"
export default component.exports